require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;

var r,
    i,
    o = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (r, i) {
  for (var o, a, l = function (e) {
    if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }(r), s = 1; s < arguments.length; s++) {
    for (var u in o = Object(arguments[s])) {
      t.call(o, u) && (l[u] = o[u]);
    }

    if (e) {
      a = e(o);

      for (var c = 0; c < a.length; c++) {
        n.call(o, a[c]) && (l[a[c]] = o[a[c]]);
      }
    }
  }

  return l;
},
    a = function a(e, t) {
  t || (t = [0, ""]), e = String(e);
  var n = parseFloat(e, 10);
  return t[0] = n, t[1] = e.match(/[\d.\-\+]*\s*(.*)/)[1] || "", t;
},
    l = function l(e) {
  return a(e)[0];
},
    s = function s(e) {
  return null == e && (e = e), function (t, n, r, i) {
    null == r && (r = e), null == i && (i = r);
    var o = a(t)[1];
    if (o === n) return t;
    var s = l(t);
    if ("px" !== o) if ("em" === o) s = l(t) * l(r);else if ("rem" === o) s = l(t) * l(e);else {
      if ("ex" !== o) return t;
      s = l(t) * l(r) * 2;
    }
    var u = s;
    if ("px" !== n) if ("em" === n) u = s / l(i);else if ("rem" === n) u = s / l(e);else {
      if ("ex" !== n) return t;
      u = s / l(i) / 2;
    }
    return parseFloat(u.toFixed(5)) + n;
  };
},
    u = a,
    c = function c(e) {
  return u(e)[1];
},
    h = function h(e) {
  return u(e)[0];
},
    f = {
  baseFontSize: "16px",
  baseLineHeight: 1.5,
  rhythmUnit: "rem",
  defaultRhythmBorderWidth: "1px",
  defaultRhythmBorderStyle: "solid",
  roundToNearestHalfLine: !0,
  minLinePadding: "2px"
},
    b = function b(e, t) {
  var n,
      r = s(t.baseFontSize),
      i = h(r(e, "px")),
      o = h(t.baseLineHeightInPx),
      a = h(r(t.minLinePadding, "px"));
  return (n = t.roundToNearestHalfLine ? Math.ceil(2 * i / o) / 2 : Math.ceil(i / o)) * o - i < 2 * a && (n += t.roundToNearestHalfLine ? .5 : 1), n;
},
    d = function d(e) {
  var t = s(e.baseFontSize);
  return function (n, r, i) {
    null == n && (n = 1), null == r && (r = e.baseFontSize), null == i && (i = 0);
    var o = n * h(e.baseLineHeightInPx) - i + "px",
        a = t(o, e.rhythmUnit, r);
    return "px" === c(a) && (a = Math.floor(h(a)) + c(a)), parseFloat(h(a).toFixed(5)) + c(a);
  };
},
    g = "[object Number]",
    p = Object.prototype.toString;

r = function r(e) {
  return "number" == typeof e || function (e) {
    return !!e && "object" == typeof e;
  }(e) && p.call(e) == g;
}, i = {
  "minor second": 16 / 15,
  "major second": 9 / 8,
  "minor third": 1.2,
  "major third": 4 / 3,
  "diminished fourth": Math.sqrt(2),
  "perfect fifth": 1.5,
  "minor sixth": 1.6,
  golden: 1.61803398875,
  phi: 1.61803398875,
  "major sixth": 5 / 3,
  "minor seventh": 16 / 9,
  "major seventh": 15 / 8,
  octave: 2,
  "major tenth": 2.5,
  "major eleventh": 8 / 3,
  "major twelfth": 3,
  "double octave": 4
};

module.exports = function (e) {
  var t,
      n,
      a,
      l,
      u = o({}, {
    baseFontSize: "16px",
    baseLineHeight: 1.45,
    headerLineHeight: 1.1,
    scaleRatio: 2,
    googleFonts: [],
    headerFontFamily: ["-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif"],
    bodyFontFamily: ["georgia", "serif"],
    headerColor: "inherit",
    bodyColor: "hsla(0,0%,0%,0.8)",
    headerWeight: "bold",
    bodyWeight: "normal",
    boldWeight: "bold",
    includeNormalize: !0,
    blockMarginBottom: 1
  }, e),
      g = (t = u, n = JSON.parse(JSON.stringify(f)), a = Object.assign({}, n, t), l = s(a.baseFontSize), c(a.baseLineHeight) ? (h(l(a.baseFontSize, "px")), a.baseLineHeightInPx = l(a.baseLineHeight, "px")) : a.baseLineHeightInPx = h(a.baseFontSize) * a.baseLineHeight + "px", {
    rhythm: d(a),
    establishBaseline: function establishBaseline() {
      return s((e = a).baseFontSize), {
        fontSize: h(e.baseFontSize) / 16 * 100 + "%",
        lineHeight: e.baseLineHeight.toString()
      };
      var e;
    },
    linesForFontSize: function linesForFontSize(e) {
      return b(e, a);
    },
    adjustFontSizeTo: function adjustFontSizeTo(e, t, n) {
      return null == t && (t = "auto"), function (e, t, n, r) {
        null == n && (n = r.baseFontSize), "%" === c(e) && (e = h(r.baseFontSize) * (h(e) / 100) + "px");
        var i = s(r.baseFontSize);
        e = i(e, "px", n = i(n, "px"));
        var o = d(r);
        return "auto" === t && (t = b(e, r)), {
          fontSize: i(e, r.rhythmUnit, n),
          lineHeight: o(t, n)
        };
      }(e, t, n, a);
    }
  });
  return g.scale = function (e) {
    var t = u.baseFontSize.slice(0, -2),
        n = function (e, t) {
      var n;
      return null == e && (e = 0), null == t && (t = "golden"), n = r(t) ? t : null != i[t] ? i[t] : i.golden, Math.pow(n, e);
    }(e, u.scaleRatio) * t + "px";

    return g.adjustFontSizeTo(n);
  }, Object.assign({}, {
    options: u
  }, g);
};